<template>
  <div class="d-flex flex-column justify-content-center align-items-center col-md-12 router-view-report-background">
    <div class="col-md-12 px-0">
      <report-filters 
        :partners="partners"
        :creators="creators"
        :user="user"
        @get-report="submitReport"  
      />
      <div class="stat-cards">
        <presentation :total_services="computedTotalServices"/>
      </div>
    </div>

    <div class="col-md-12 px-0 d-flex justify-content-end" v-if="showStatus">
      <div class="col-md-3 px-0">
        <v-select
          outlined
          dense
          label="Status"
          item-text="title"
          item-value="id"
          :items="computedStatus"
          v-model="filters.status"
          hide-details
        ></v-select>
      </div>
    </div>

    <div class="col-md-12 px-0">
      <the-table 
        id="service-validated-report"
        :dataItems="computedServices"
        :headers="headersForTable"
      >
        <template v-slot:animals="{item}">
          <a class="text-link" @click="showAnimals(item)">{{item.animals.length}}</a>
        </template>
        <template v-slot:actions="{item}">
          <span class="d-flex justify-content-center">
            <v-btn small outlined color="primary" @click="redirect(item)"><i class="mdi mdi-eye-outline pr-1"></i>Detalhes</v-btn>
          </span>
        </template>
      </the-table>
    </div>

    <modal-animals 
      :active="animalsModal"
      :service="serviceModal"
      @close="animalsModal = false"
    />

    <button-export
      :print="true"
      @print="PDFPrint"
      v-if="services_report.services && services_report.services.length"
      :excel="true"
      :data="computedExcel"
      :title="'Relatório de Serviços validados'"
      @export-pdf="PDFExport"
    />
  </div>
</template>

<script>
import Presentation from "./Presentation";
import ReportFilters from "./ReportFilters";
import TheTable from "@/components/layout/TheTable";
import ModalAnimals from "./ModalAnimals";
import ButtonExport from "@/components/layout/ButtonExport";
import {mapState, mapActions} from "vuex";
import { exportOfficialTablePdf } from "@/utils/officialPdf";
export default {
  name:"ServiceReport",
  components: {
    Presentation,
    ReportFilters,
    TheTable,
    ModalAnimals,
    ButtonExport
  },
  data() {
    return {
      headersForTable:[
        {text:"Nº Serviço", value:"code", sortable:true},
        {text:"Fazenda", value:"property", sortable:true},
        {text:"Controlador", value:"partner", sortable:true},
        {text:"Animais", value:"animals", sortable:true, has_slot:true},
        {text:"Data do Serviço", value:"created_at", sortable:true},
        {text:"Data da Pesagem", value:"date", sortable:true},
        {text:"Data da Validação", value:"date_close", sortable:true},
        {text:"Qtde Mensurados", value:"animals_mensures_count", sortable:true},
        {text:"Qtde Encerrados", value:"animals_closed_count", sortable:true},
        {text:"", value:"actions", has_slot:true},
      ],
      animalsModal:false,
      serviceModal:{},
      filters:{},
      showStatus:false
    }
  },
  computed: {
    ...mapState("validated_services_report", ["services_report"]),
    ...mapState("partners", ["partners"]),
    ...mapState("creators", ["creators"]),
    ...mapState("login", ["user"]),
    computedTotalServices() {
      return this.services_report.total_services
    },
    computedServices() {
      if(this.services_report.services) {
        return this.services_report.services.map(e => ({...e,property:e.farm.name, partner:e.partner.name, animals_pi_count_length:e.animals_pi_count.length}));
      }
      else {
        return [];
      }
    },
    computedExcel() {
      if(this.services_report.services) {
        return [
          ...this.services_report.services.map(e => 
          ({
            "Total de Serviços":this.services_report.total_services,
            "Código":e.code,
            "Data do Serviço":e.created_at,
            "Data da Pesagem":e.date,
            "Data da Validação":e.date_close,
            Animais:e.animals.length,
            Propriedade:e.farm.name,
            Controlador:e.partner.name
          }))
        ]
      } else {
        return [];
      }
    },
    computedStatus() {
      return [
        {title:"Em Preenchimento", id:"open"},
        {title:"Pendente", id:"pending"},
        {title:"Finalizado", id:"close"},
        {title:"Parcialmente Aprovado", id:"unaproved"},
        {title:"Classificado", id:"classified"},
      ]
    }
  },
  methods: {
    ...mapActions("validated_services_report", ["actionGetServiceReport"]),
    ...mapActions("partners",["actionGetPartners"]),
    ...mapActions("creators", ["actionGetCreators"]),
    async submitReport(filter) {
      this.showStatus = true;
      this.filters = {...filter, status:this.filters.status ? this.filters.status : "validated"};
      await this.actionGetServiceReport(this.filters);
    },
    showAnimals(service) {
      this.serviceModal = service;
      this.animalsModal = true;
    },
    async PDFExport(print = false) {
      const { date, date_end } = this.filters;
      return exportOfficialTablePdf({
        table: "#service-validated-report", title: "RELATÓRIO DE SERVIÇOS VALIDADOS",
        details: [`Período: ${date || "-"} até ${date_end || "-"}`, `Total de serviços: ${this.computedTotalServices || 0}`],
        filename: `relatorio_servicos_validados_${Date.now()}.pdf`, print
      });
    },
    async PDFPrint() {
      await this.PDFExport(true);
    },
    redirect(item) {
      const route = this.$router.resolve({name:'Services-details', params:{id:item.id}});
      window.open(route.href, "_blank");
    }
  },
  async mounted() {
    await this.actionGetPartners();
    await this.actionGetCreators();
  }
}
</script>

<style>

</style>